export default "__VITE_ASSET__DZtfLnFJ__"